<template>
  <div>
    <p class="cm-mg-p-wzd">1.1 {{ $t('pqr.client_general_info') }}</p>
    <hr />
    <div class="row">
      <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-2">
        <fg-input
          type="text"
          v-model="model.nit"
          :label="`${$t('common_words.nit')}: *`"
          name="common_words.nit"
          v-validate="'required'"
          :error="getError('common_words.nit', true)"
        ></fg-input>
      </div>
      <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4">
        <fg-input
          type="text"
          :label="`${$t('common_words.name')}: *`"
          v-model="model.name"
          name="common_words.name"
          v-validate="'required'"
          :error="getError('common_words.name', true)"
        >
        </fg-input>
      </div>
      <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4">
        <fg-input
          type="text"
          :label="`${$t('common_words.comercial_name')}:`"
          v-model="model.tradename"
        ></fg-input>
      </div>

      <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4">
        <div class="form-group has-label">
          <label class="text-transform-none"
            >{{ $t('common_words.select_companies') }} *</label
          >
          <br />
          <el-select
            @change="selectAllFromSelect('model.business_ids', businesses)"
            clearable
            multiple
            v-bind:collapse-tags="true"
            class="select-primary custom-width-select shadow-sm required-businesses"
            v-model="model.business_ids"
            filterable
            p:placeholder=" $t('common_words.select_companies')"
          >
            <el-option
              v-for="option in businesses"
              class="select-primary selected-all"
              :value="option.id"
              :label="option.name"
              :key="option.name"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-2">
        <fg-input
          type="text"
          :label="`${$t('common_words.phone')}:`"
          v-model="model.phone"
          v-validate="{ required: false, regex: '^[^a-zA-Z]+$' }"
          name="common_words.phone"
          :error="getError('common_words.phone', true)"
        ></fg-input>
      </div>
      <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-6">
        <fg-input
          type="text"
          :label="`${$t('common_words.email')}:`"
          v-model="model.email"
          name="common_words.email"
          v-validate="'email'"
          :error="getError('common_words.email', true)"
        >
        </fg-input>
      </div>
      <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-6">
        <fg-input
          type="text"
          :label="`${$t('common_words.website')}:`"
          v-model="model.web_site"
        ></fg-input>
      </div>
      <div class="col-12">
        <div class="form-group has-label">
          <div class="form-group has-label">
            <label>{{ $t('common_words.economic_activity') }}:</label>
            <br />
            <el-input
              maxlength="150"
              show-word-limit
              class="shadow-sm"
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 5 }"
              v-model="model.comercial_activity"
            ></el-input>
            <br />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import MixinForm from 'src/mixins/forms/mixin-form';
import mixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';
import SweetAlert from 'src/class/Alerts';
import { Axios } from 'src/class/Axios.js';

export default {
  data() {
    return {
      model: {
        nit: null,
        name: null,
        business_ids: null,
        phone: null,
        email: null,
        tradename: null,
        web_site: null,
        comercial_activity: null,
      },
      businesses: null,
    };
  },

  mixins: [MixinPermissions, mixinMasters, MixinForm],

  watch: {
    '$i18n.locale': 'getSelectAll',
  },

  methods: {
    getSelectAll() {
      this.businesses = this.concatAll(this.businesses.splice(1));
    },
    validate() {
      return this.$validator.validateAll().then((response) => {
        if (this.model.business_ids.length == 0) {
          return this.validationInputsRequired('businesses');
        }

        this.$emit('on-validated', response, { ...this.model });

        let others = [];
        this.businesses.forEach((item) => {
          this.model.business_ids.forEach((element) => {
            if (element == item.id) {
              others.push(item.name);
            }
          });
        });

        this.$emit('fillBusinessForm', 'secondStep', {
          business_names: others,
        });

        return response;
      });
    },
  },

  mounted() {
    if (this.isCreate() || this.isUpdate()) {
      this.showHideLoading(true);

      Axios.getMasters('businesses/only')
        .then((response) => {
          this.businesses = this.concatAll(response.data.data);

          let editForm = JSON.parse(sessionStorage.getItem('editForm'));
          if (this.isUpdate() && editForm) {
            this.model = { ...editForm };
          }

          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    } else {
      this.showHideLoading();
    }
  },
};
</script>
